import Draft from 'draft-js';

export const contentSourceHasText = (contentSource) => {
  if (!contentSource) {
    return false;
  }
  if (typeof contentSource === 'string') {
    return Boolean(contentSource);
  }
  const draftState = Draft.convertFromRaw(contentSource);
  return draftState.hasText();
};
